/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "ru-BY": {
        "nu": ["latn"],
        "year": {
          "0": "в этом году",
          "1": "в следующем году",
          "future": {
            "one": "через {0} год",
            "few": "через {0} года",
            "many": "через {0} лет",
            "other": "через {0} года"
          },
          "past": {
            "one": "{0} год назад",
            "few": "{0} года назад",
            "many": "{0} лет назад",
            "other": "{0} года назад"
          },
          "-1": "в прошлом году"
        },
        "year-short": {
          "0": "в этом г.",
          "1": "в след. г.",
          "future": {
            "one": "через {0} г.",
            "few": "через {0} г.",
            "many": "через {0} л.",
            "other": "через {0} г."
          },
          "past": {
            "one": "{0} г. назад",
            "few": "{0} г. назад",
            "many": "{0} л. назад",
            "other": "{0} г. назад"
          },
          "-1": "в прошлом г."
        },
        "year-narrow": {
          "0": "в эт. г.",
          "1": "в сл. г.",
          "future": {
            "one": "+{0} г.",
            "few": "+{0} г.",
            "many": "+{0} л.",
            "other": "+{0} г."
          },
          "past": {
            "one": "-{0} г.",
            "few": "-{0} г.",
            "many": "-{0} л.",
            "other": "-{0} г."
          },
          "-1": "в пр. г."
        },
        "quarter": {
          "0": "в текущем квартале",
          "1": "в следующем квартале",
          "future": {
            "one": "через {0} квартал",
            "few": "через {0} квартала",
            "many": "через {0} кварталов",
            "other": "через {0} квартала"
          },
          "past": {
            "one": "{0} квартал назад",
            "few": "{0} квартала назад",
            "many": "{0} кварталов назад",
            "other": "{0} квартала назад"
          },
          "-1": "в прошлом квартале"
        },
        "quarter-short": {
          "0": "текущий кв.",
          "1": "следующий кв.",
          "future": {
            "one": "через {0} кв.",
            "few": "через {0} кв.",
            "many": "через {0} кв.",
            "other": "через {0} кв."
          },
          "past": {
            "one": "{0} кв. назад",
            "few": "{0} кв. назад",
            "many": "{0} кв. назад",
            "other": "{0} кв. назад"
          },
          "-1": "последний кв."
        },
        "quarter-narrow": {
          "0": "тек. кв.",
          "1": "след. кв.",
          "future": {
            "one": "+{0} кв.",
            "few": "+{0} кв.",
            "many": "+{0} кв.",
            "other": "+{0} кв."
          },
          "past": {
            "one": "-{0} кв.",
            "few": "-{0} кв.",
            "many": "-{0} кв.",
            "other": "-{0} кв."
          },
          "-1": "посл. кв."
        },
        "month": {
          "0": "в этом месяце",
          "1": "в следующем месяце",
          "future": {
            "one": "через {0} месяц",
            "few": "через {0} месяца",
            "many": "через {0} месяцев",
            "other": "через {0} месяца"
          },
          "past": {
            "one": "{0} месяц назад",
            "few": "{0} месяца назад",
            "many": "{0} месяцев назад",
            "other": "{0} месяца назад"
          },
          "-1": "в прошлом месяце"
        },
        "month-short": {
          "0": "в этом мес.",
          "1": "в следующем мес.",
          "future": {
            "one": "через {0} мес.",
            "few": "через {0} мес.",
            "many": "через {0} мес.",
            "other": "через {0} мес."
          },
          "past": {
            "one": "{0} мес. назад",
            "few": "{0} мес. назад",
            "many": "{0} мес. назад",
            "other": "{0} мес. назад"
          },
          "-1": "в прошлом мес."
        },
        "month-narrow": {
          "0": "в эт. мес.",
          "1": "в след. мес.",
          "future": {
            "one": "+{0} мес.",
            "few": "+{0} мес.",
            "many": "+{0} мес.",
            "other": "+{0} мес."
          },
          "past": {
            "one": "-{0} мес.",
            "few": "-{0} мес.",
            "many": "-{0} мес.",
            "other": "-{0} мес."
          },
          "-1": "в пр. мес."
        },
        "week": {
          "0": "на этой неделе",
          "1": "на следующей неделе",
          "future": {
            "one": "через {0} неделю",
            "few": "через {0} недели",
            "many": "через {0} недель",
            "other": "через {0} недели"
          },
          "past": {
            "one": "{0} неделю назад",
            "few": "{0} недели назад",
            "many": "{0} недель назад",
            "other": "{0} недели назад"
          },
          "-1": "на прошлой неделе"
        },
        "week-short": {
          "0": "на этой нед.",
          "1": "на следующей нед.",
          "future": {
            "one": "через {0} нед.",
            "few": "через {0} нед.",
            "many": "через {0} нед.",
            "other": "через {0} нед."
          },
          "past": {
            "one": "{0} нед. назад",
            "few": "{0} нед. назад",
            "many": "{0} нед. назад",
            "other": "{0} нед. назад"
          },
          "-1": "на прошлой нед."
        },
        "week-narrow": {
          "0": "на эт. нед.",
          "1": "на след. нед.",
          "future": {
            "one": "+{0} нед.",
            "few": "+{0} нед.",
            "many": "+{0} нед.",
            "other": "+{0} нед."
          },
          "past": {
            "one": "-{0} нед.",
            "few": "-{0} нед.",
            "many": "-{0} нед.",
            "other": "-{0} нед."
          },
          "-1": "на пр. нед."
        },
        "day": {
          "0": "сегодня",
          "1": "завтра",
          "2": "послезавтра",
          "future": {
            "one": "через {0} день",
            "few": "через {0} дня",
            "many": "через {0} дней",
            "other": "через {0} дня"
          },
          "past": {
            "one": "{0} день назад",
            "few": "{0} дня назад",
            "many": "{0} дней назад",
            "other": "{0} дня назад"
          },
          "-2": "позавчера",
          "-1": "вчера"
        },
        "day-short": {
          "0": "сегодня",
          "1": "завтра",
          "2": "послезавтра",
          "future": {
            "one": "через {0} дн.",
            "few": "через {0} дн.",
            "many": "через {0} дн.",
            "other": "через {0} дн."
          },
          "past": {
            "one": "{0} дн. назад",
            "few": "{0} дн. назад",
            "many": "{0} дн. назад",
            "other": "{0} дн. назад"
          },
          "-2": "позавчера",
          "-1": "вчера"
        },
        "day-narrow": {
          "0": "сегодня",
          "1": "завтра",
          "2": "послезавтра",
          "future": {
            "one": "+{0} дн.",
            "few": "+{0} дн.",
            "many": "+{0} дн.",
            "other": "+{0} дн."
          },
          "past": {
            "one": "-{0} дн.",
            "few": "-{0} дн.",
            "many": "-{0} дн.",
            "other": "-{0} дн."
          },
          "-2": "позавчера",
          "-1": "вчера"
        },
        "hour": {
          "0": "в этот час",
          "future": {
            "one": "через {0} час",
            "few": "через {0} часа",
            "many": "через {0} часов",
            "other": "через {0} часа"
          },
          "past": {
            "one": "{0} час назад",
            "few": "{0} часа назад",
            "many": "{0} часов назад",
            "other": "{0} часа назад"
          }
        },
        "hour-short": {
          "0": "в этот час",
          "future": {
            "one": "через {0} ч",
            "few": "через {0} ч",
            "many": "через {0} ч",
            "other": "через {0} ч"
          },
          "past": {
            "one": "{0} ч назад",
            "few": "{0} ч назад",
            "many": "{0} ч назад",
            "other": "{0} ч назад"
          }
        },
        "hour-narrow": {
          "0": "в этот час",
          "future": {
            "one": "+{0} ч",
            "few": "+{0} ч",
            "many": "+{0} ч",
            "other": "+{0} ч"
          },
          "past": {
            "one": "-{0} ч",
            "few": "-{0} ч",
            "many": "-{0} ч",
            "other": "-{0} ч"
          }
        },
        "minute": {
          "0": "в эту минуту",
          "future": {
            "one": "через {0} минуту",
            "few": "через {0} минуты",
            "many": "через {0} минут",
            "other": "через {0} минуты"
          },
          "past": {
            "one": "{0} минуту назад",
            "few": "{0} минуты назад",
            "many": "{0} минут назад",
            "other": "{0} минуты назад"
          }
        },
        "minute-short": {
          "0": "в эту минуту",
          "future": {
            "one": "через {0} мин.",
            "few": "через {0} мин.",
            "many": "через {0} мин.",
            "other": "через {0} мин."
          },
          "past": {
            "one": "{0} мин. назад",
            "few": "{0} мин. назад",
            "many": "{0} мин. назад",
            "other": "{0} мин. назад"
          }
        },
        "minute-narrow": {
          "0": "в эту минуту",
          "future": {
            "one": "+{0} мин",
            "few": "+{0} мин",
            "many": "+{0} мин",
            "other": "+{0} мин"
          },
          "past": {
            "one": "-{0} мин",
            "few": "-{0} мин",
            "many": "-{0} мин",
            "other": "-{0} мин"
          }
        },
        "second": {
          "0": "сейчас",
          "future": {
            "one": "через {0} секунду",
            "few": "через {0} секунды",
            "many": "через {0} секунд",
            "other": "через {0} секунды"
          },
          "past": {
            "one": "{0} секунду назад",
            "few": "{0} секунды назад",
            "many": "{0} секунд назад",
            "other": "{0} секунды назад"
          }
        },
        "second-short": {
          "0": "сейчас",
          "future": {
            "one": "через {0} сек.",
            "few": "через {0} сек.",
            "many": "через {0} сек.",
            "other": "через {0} сек."
          },
          "past": {
            "one": "{0} сек. назад",
            "few": "{0} сек. назад",
            "many": "{0} сек. назад",
            "other": "{0} сек. назад"
          }
        },
        "second-narrow": {
          "0": "сейчас",
          "future": {
            "one": "+{0} с",
            "few": "+{0} с",
            "many": "+{0} с",
            "other": "+{0} с"
          },
          "past": {
            "one": "-{0} с",
            "few": "-{0} с",
            "many": "-{0} с",
            "other": "-{0} с"
          }
        }
      },
      "ru-KG": {
        "nu": ["latn"],
        "year": {
          "0": "в этом году",
          "1": "в следующем году",
          "future": {
            "one": "через {0} год",
            "few": "через {0} года",
            "many": "через {0} лет",
            "other": "через {0} года"
          },
          "past": {
            "one": "{0} год назад",
            "few": "{0} года назад",
            "many": "{0} лет назад",
            "other": "{0} года назад"
          },
          "-1": "в прошлом году"
        },
        "year-short": {
          "0": "в этом г.",
          "1": "в след. г.",
          "future": {
            "one": "через {0} г.",
            "few": "через {0} г.",
            "many": "через {0} л.",
            "other": "через {0} г."
          },
          "past": {
            "one": "{0} г. назад",
            "few": "{0} г. назад",
            "many": "{0} л. назад",
            "other": "{0} г. назад"
          },
          "-1": "в прошлом г."
        },
        "year-narrow": {
          "0": "в эт. г.",
          "1": "в сл. г.",
          "future": {
            "one": "+{0} г.",
            "few": "+{0} г.",
            "many": "+{0} л.",
            "other": "+{0} г."
          },
          "past": {
            "one": "-{0} г.",
            "few": "-{0} г.",
            "many": "-{0} л.",
            "other": "-{0} г."
          },
          "-1": "в пр. г."
        },
        "quarter": {
          "0": "в текущем квартале",
          "1": "в следующем квартале",
          "future": {
            "one": "через {0} квартал",
            "few": "через {0} квартала",
            "many": "через {0} кварталов",
            "other": "через {0} квартала"
          },
          "past": {
            "one": "{0} квартал назад",
            "few": "{0} квартала назад",
            "many": "{0} кварталов назад",
            "other": "{0} квартала назад"
          },
          "-1": "в прошлом квартале"
        },
        "quarter-short": {
          "0": "текущий кв.",
          "1": "следующий кв.",
          "future": {
            "one": "через {0} кв.",
            "few": "через {0} кв.",
            "many": "через {0} кв.",
            "other": "через {0} кв."
          },
          "past": {
            "one": "{0} кв. назад",
            "few": "{0} кв. назад",
            "many": "{0} кв. назад",
            "other": "{0} кв. назад"
          },
          "-1": "последний кв."
        },
        "quarter-narrow": {
          "0": "тек. кв.",
          "1": "след. кв.",
          "future": {
            "one": "+{0} кв.",
            "few": "+{0} кв.",
            "many": "+{0} кв.",
            "other": "+{0} кв."
          },
          "past": {
            "one": "-{0} кв.",
            "few": "-{0} кв.",
            "many": "-{0} кв.",
            "other": "-{0} кв."
          },
          "-1": "посл. кв."
        },
        "month": {
          "0": "в этом месяце",
          "1": "в следующем месяце",
          "future": {
            "one": "через {0} месяц",
            "few": "через {0} месяца",
            "many": "через {0} месяцев",
            "other": "через {0} месяца"
          },
          "past": {
            "one": "{0} месяц назад",
            "few": "{0} месяца назад",
            "many": "{0} месяцев назад",
            "other": "{0} месяца назад"
          },
          "-1": "в прошлом месяце"
        },
        "month-short": {
          "0": "в этом мес.",
          "1": "в следующем мес.",
          "future": {
            "one": "через {0} мес.",
            "few": "через {0} мес.",
            "many": "через {0} мес.",
            "other": "через {0} мес."
          },
          "past": {
            "one": "{0} мес. назад",
            "few": "{0} мес. назад",
            "many": "{0} мес. назад",
            "other": "{0} мес. назад"
          },
          "-1": "в прошлом мес."
        },
        "month-narrow": {
          "0": "в эт. мес.",
          "1": "в след. мес.",
          "future": {
            "one": "+{0} мес.",
            "few": "+{0} мес.",
            "many": "+{0} мес.",
            "other": "+{0} мес."
          },
          "past": {
            "one": "-{0} мес.",
            "few": "-{0} мес.",
            "many": "-{0} мес.",
            "other": "-{0} мес."
          },
          "-1": "в пр. мес."
        },
        "week": {
          "0": "на этой неделе",
          "1": "на следующей неделе",
          "future": {
            "one": "через {0} неделю",
            "few": "через {0} недели",
            "many": "через {0} недель",
            "other": "через {0} недели"
          },
          "past": {
            "one": "{0} неделю назад",
            "few": "{0} недели назад",
            "many": "{0} недель назад",
            "other": "{0} недели назад"
          },
          "-1": "на прошлой неделе"
        },
        "week-short": {
          "0": "на этой нед.",
          "1": "на следующей нед.",
          "future": {
            "one": "через {0} нед.",
            "few": "через {0} нед.",
            "many": "через {0} нед.",
            "other": "через {0} нед."
          },
          "past": {
            "one": "{0} нед. назад",
            "few": "{0} нед. назад",
            "many": "{0} нед. назад",
            "other": "{0} нед. назад"
          },
          "-1": "на прошлой нед."
        },
        "week-narrow": {
          "0": "на эт. нед.",
          "1": "на след. нед.",
          "future": {
            "one": "+{0} нед.",
            "few": "+{0} нед.",
            "many": "+{0} нед.",
            "other": "+{0} нед."
          },
          "past": {
            "one": "-{0} нед.",
            "few": "-{0} нед.",
            "many": "-{0} нед.",
            "other": "-{0} нед."
          },
          "-1": "на пр. нед."
        },
        "day": {
          "0": "сегодня",
          "1": "завтра",
          "2": "послезавтра",
          "future": {
            "one": "через {0} день",
            "few": "через {0} дня",
            "many": "через {0} дней",
            "other": "через {0} дня"
          },
          "past": {
            "one": "{0} день назад",
            "few": "{0} дня назад",
            "many": "{0} дней назад",
            "other": "{0} дня назад"
          },
          "-2": "позавчера",
          "-1": "вчера"
        },
        "day-short": {
          "0": "сегодня",
          "1": "завтра",
          "2": "послезавтра",
          "future": {
            "one": "через {0} дн.",
            "few": "через {0} дн.",
            "many": "через {0} дн.",
            "other": "через {0} дн."
          },
          "past": {
            "one": "{0} дн. назад",
            "few": "{0} дн. назад",
            "many": "{0} дн. назад",
            "other": "{0} дн. назад"
          },
          "-2": "позавчера",
          "-1": "вчера"
        },
        "day-narrow": {
          "0": "сегодня",
          "1": "завтра",
          "2": "послезавтра",
          "future": {
            "one": "+{0} дн.",
            "few": "+{0} дн.",
            "many": "+{0} дн.",
            "other": "+{0} дн."
          },
          "past": {
            "one": "-{0} дн.",
            "few": "-{0} дн.",
            "many": "-{0} дн.",
            "other": "-{0} дн."
          },
          "-2": "позавчера",
          "-1": "вчера"
        },
        "hour": {
          "0": "в этот час",
          "future": {
            "one": "через {0} час",
            "few": "через {0} часа",
            "many": "через {0} часов",
            "other": "через {0} часа"
          },
          "past": {
            "one": "{0} час назад",
            "few": "{0} часа назад",
            "many": "{0} часов назад",
            "other": "{0} часа назад"
          }
        },
        "hour-short": {
          "0": "в этот час",
          "future": {
            "one": "через {0} ч",
            "few": "через {0} ч",
            "many": "через {0} ч",
            "other": "через {0} ч"
          },
          "past": {
            "one": "{0} ч назад",
            "few": "{0} ч назад",
            "many": "{0} ч назад",
            "other": "{0} ч назад"
          }
        },
        "hour-narrow": {
          "0": "в этот час",
          "future": {
            "one": "+{0} ч",
            "few": "+{0} ч",
            "many": "+{0} ч",
            "other": "+{0} ч"
          },
          "past": {
            "one": "-{0} ч",
            "few": "-{0} ч",
            "many": "-{0} ч",
            "other": "-{0} ч"
          }
        },
        "minute": {
          "0": "в эту минуту",
          "future": {
            "one": "через {0} минуту",
            "few": "через {0} минуты",
            "many": "через {0} минут",
            "other": "через {0} минуты"
          },
          "past": {
            "one": "{0} минуту назад",
            "few": "{0} минуты назад",
            "many": "{0} минут назад",
            "other": "{0} минуты назад"
          }
        },
        "minute-short": {
          "0": "в эту минуту",
          "future": {
            "one": "через {0} мин.",
            "few": "через {0} мин.",
            "many": "через {0} мин.",
            "other": "через {0} мин."
          },
          "past": {
            "one": "{0} мин. назад",
            "few": "{0} мин. назад",
            "many": "{0} мин. назад",
            "other": "{0} мин. назад"
          }
        },
        "minute-narrow": {
          "0": "в эту минуту",
          "future": {
            "one": "+{0} мин",
            "few": "+{0} мин",
            "many": "+{0} мин",
            "other": "+{0} мин"
          },
          "past": {
            "one": "-{0} мин",
            "few": "-{0} мин",
            "many": "-{0} мин",
            "other": "-{0} мин"
          }
        },
        "second": {
          "0": "сейчас",
          "future": {
            "one": "через {0} секунду",
            "few": "через {0} секунды",
            "many": "через {0} секунд",
            "other": "через {0} секунды"
          },
          "past": {
            "one": "{0} секунду назад",
            "few": "{0} секунды назад",
            "many": "{0} секунд назад",
            "other": "{0} секунды назад"
          }
        },
        "second-short": {
          "0": "сейчас",
          "future": {
            "one": "через {0} сек.",
            "few": "через {0} сек.",
            "many": "через {0} сек.",
            "other": "через {0} сек."
          },
          "past": {
            "one": "{0} сек. назад",
            "few": "{0} сек. назад",
            "many": "{0} сек. назад",
            "other": "{0} сек. назад"
          }
        },
        "second-narrow": {
          "0": "сейчас",
          "future": {
            "one": "+{0} с",
            "few": "+{0} с",
            "many": "+{0} с",
            "other": "+{0} с"
          },
          "past": {
            "one": "-{0} с",
            "few": "-{0} с",
            "many": "-{0} с",
            "other": "-{0} с"
          }
        }
      },
      "ru-KZ": {
        "nu": ["latn"],
        "year": {
          "0": "в этом году",
          "1": "в следующем году",
          "future": {
            "one": "через {0} год",
            "few": "через {0} года",
            "many": "через {0} лет",
            "other": "через {0} года"
          },
          "past": {
            "one": "{0} год назад",
            "few": "{0} года назад",
            "many": "{0} лет назад",
            "other": "{0} года назад"
          },
          "-1": "в прошлом году"
        },
        "year-short": {
          "0": "в этом г.",
          "1": "в след. г.",
          "future": {
            "one": "через {0} г.",
            "few": "через {0} г.",
            "many": "через {0} л.",
            "other": "через {0} г."
          },
          "past": {
            "one": "{0} г. назад",
            "few": "{0} г. назад",
            "many": "{0} л. назад",
            "other": "{0} г. назад"
          },
          "-1": "в прошлом г."
        },
        "year-narrow": {
          "0": "в эт. г.",
          "1": "в сл. г.",
          "future": {
            "one": "+{0} г.",
            "few": "+{0} г.",
            "many": "+{0} л.",
            "other": "+{0} г."
          },
          "past": {
            "one": "-{0} г.",
            "few": "-{0} г.",
            "many": "-{0} л.",
            "other": "-{0} г."
          },
          "-1": "в пр. г."
        },
        "quarter": {
          "0": "в текущем квартале",
          "1": "в следующем квартале",
          "future": {
            "one": "через {0} квартал",
            "few": "через {0} квартала",
            "many": "через {0} кварталов",
            "other": "через {0} квартала"
          },
          "past": {
            "one": "{0} квартал назад",
            "few": "{0} квартала назад",
            "many": "{0} кварталов назад",
            "other": "{0} квартала назад"
          },
          "-1": "в прошлом квартале"
        },
        "quarter-short": {
          "0": "текущий кв.",
          "1": "следующий кв.",
          "future": {
            "one": "через {0} кв.",
            "few": "через {0} кв.",
            "many": "через {0} кв.",
            "other": "через {0} кв."
          },
          "past": {
            "one": "{0} кв. назад",
            "few": "{0} кв. назад",
            "many": "{0} кв. назад",
            "other": "{0} кв. назад"
          },
          "-1": "последний кв."
        },
        "quarter-narrow": {
          "0": "тек. кв.",
          "1": "след. кв.",
          "future": {
            "one": "+{0} кв.",
            "few": "+{0} кв.",
            "many": "+{0} кв.",
            "other": "+{0} кв."
          },
          "past": {
            "one": "-{0} кв.",
            "few": "-{0} кв.",
            "many": "-{0} кв.",
            "other": "-{0} кв."
          },
          "-1": "посл. кв."
        },
        "month": {
          "0": "в этом месяце",
          "1": "в следующем месяце",
          "future": {
            "one": "через {0} месяц",
            "few": "через {0} месяца",
            "many": "через {0} месяцев",
            "other": "через {0} месяца"
          },
          "past": {
            "one": "{0} месяц назад",
            "few": "{0} месяца назад",
            "many": "{0} месяцев назад",
            "other": "{0} месяца назад"
          },
          "-1": "в прошлом месяце"
        },
        "month-short": {
          "0": "в этом мес.",
          "1": "в следующем мес.",
          "future": {
            "one": "через {0} мес.",
            "few": "через {0} мес.",
            "many": "через {0} мес.",
            "other": "через {0} мес."
          },
          "past": {
            "one": "{0} мес. назад",
            "few": "{0} мес. назад",
            "many": "{0} мес. назад",
            "other": "{0} мес. назад"
          },
          "-1": "в прошлом мес."
        },
        "month-narrow": {
          "0": "в эт. мес.",
          "1": "в след. мес.",
          "future": {
            "one": "+{0} мес.",
            "few": "+{0} мес.",
            "many": "+{0} мес.",
            "other": "+{0} мес."
          },
          "past": {
            "one": "-{0} мес.",
            "few": "-{0} мес.",
            "many": "-{0} мес.",
            "other": "-{0} мес."
          },
          "-1": "в пр. мес."
        },
        "week": {
          "0": "на этой неделе",
          "1": "на следующей неделе",
          "future": {
            "one": "через {0} неделю",
            "few": "через {0} недели",
            "many": "через {0} недель",
            "other": "через {0} недели"
          },
          "past": {
            "one": "{0} неделю назад",
            "few": "{0} недели назад",
            "many": "{0} недель назад",
            "other": "{0} недели назад"
          },
          "-1": "на прошлой неделе"
        },
        "week-short": {
          "0": "на этой нед.",
          "1": "на следующей нед.",
          "future": {
            "one": "через {0} нед.",
            "few": "через {0} нед.",
            "many": "через {0} нед.",
            "other": "через {0} нед."
          },
          "past": {
            "one": "{0} нед. назад",
            "few": "{0} нед. назад",
            "many": "{0} нед. назад",
            "other": "{0} нед. назад"
          },
          "-1": "на прошлой нед."
        },
        "week-narrow": {
          "0": "на эт. нед.",
          "1": "на след. нед.",
          "future": {
            "one": "+{0} нед.",
            "few": "+{0} нед.",
            "many": "+{0} нед.",
            "other": "+{0} нед."
          },
          "past": {
            "one": "-{0} нед.",
            "few": "-{0} нед.",
            "many": "-{0} нед.",
            "other": "-{0} нед."
          },
          "-1": "на пр. нед."
        },
        "day": {
          "0": "сегодня",
          "1": "завтра",
          "2": "послезавтра",
          "future": {
            "one": "через {0} день",
            "few": "через {0} дня",
            "many": "через {0} дней",
            "other": "через {0} дня"
          },
          "past": {
            "one": "{0} день назад",
            "few": "{0} дня назад",
            "many": "{0} дней назад",
            "other": "{0} дня назад"
          },
          "-2": "позавчера",
          "-1": "вчера"
        },
        "day-short": {
          "0": "сегодня",
          "1": "завтра",
          "2": "послезавтра",
          "future": {
            "one": "через {0} дн.",
            "few": "через {0} дн.",
            "many": "через {0} дн.",
            "other": "через {0} дн."
          },
          "past": {
            "one": "{0} дн. назад",
            "few": "{0} дн. назад",
            "many": "{0} дн. назад",
            "other": "{0} дн. назад"
          },
          "-2": "позавчера",
          "-1": "вчера"
        },
        "day-narrow": {
          "0": "сегодня",
          "1": "завтра",
          "2": "послезавтра",
          "future": {
            "one": "+{0} дн.",
            "few": "+{0} дн.",
            "many": "+{0} дн.",
            "other": "+{0} дн."
          },
          "past": {
            "one": "-{0} дн.",
            "few": "-{0} дн.",
            "many": "-{0} дн.",
            "other": "-{0} дн."
          },
          "-2": "позавчера",
          "-1": "вчера"
        },
        "hour": {
          "0": "в этот час",
          "future": {
            "one": "через {0} час",
            "few": "через {0} часа",
            "many": "через {0} часов",
            "other": "через {0} часа"
          },
          "past": {
            "one": "{0} час назад",
            "few": "{0} часа назад",
            "many": "{0} часов назад",
            "other": "{0} часа назад"
          }
        },
        "hour-short": {
          "0": "в этот час",
          "future": {
            "one": "через {0} ч",
            "few": "через {0} ч",
            "many": "через {0} ч",
            "other": "через {0} ч"
          },
          "past": {
            "one": "{0} ч назад",
            "few": "{0} ч назад",
            "many": "{0} ч назад",
            "other": "{0} ч назад"
          }
        },
        "hour-narrow": {
          "0": "в этот час",
          "future": {
            "one": "+{0} ч",
            "few": "+{0} ч",
            "many": "+{0} ч",
            "other": "+{0} ч"
          },
          "past": {
            "one": "-{0} ч",
            "few": "-{0} ч",
            "many": "-{0} ч",
            "other": "-{0} ч"
          }
        },
        "minute": {
          "0": "в эту минуту",
          "future": {
            "one": "через {0} минуту",
            "few": "через {0} минуты",
            "many": "через {0} минут",
            "other": "через {0} минуты"
          },
          "past": {
            "one": "{0} минуту назад",
            "few": "{0} минуты назад",
            "many": "{0} минут назад",
            "other": "{0} минуты назад"
          }
        },
        "minute-short": {
          "0": "в эту минуту",
          "future": {
            "one": "через {0} мин.",
            "few": "через {0} мин.",
            "many": "через {0} мин.",
            "other": "через {0} мин."
          },
          "past": {
            "one": "{0} мин. назад",
            "few": "{0} мин. назад",
            "many": "{0} мин. назад",
            "other": "{0} мин. назад"
          }
        },
        "minute-narrow": {
          "0": "в эту минуту",
          "future": {
            "one": "+{0} мин",
            "few": "+{0} мин",
            "many": "+{0} мин",
            "other": "+{0} мин"
          },
          "past": {
            "one": "-{0} мин",
            "few": "-{0} мин",
            "many": "-{0} мин",
            "other": "-{0} мин"
          }
        },
        "second": {
          "0": "сейчас",
          "future": {
            "one": "через {0} секунду",
            "few": "через {0} секунды",
            "many": "через {0} секунд",
            "other": "через {0} секунды"
          },
          "past": {
            "one": "{0} секунду назад",
            "few": "{0} секунды назад",
            "many": "{0} секунд назад",
            "other": "{0} секунды назад"
          }
        },
        "second-short": {
          "0": "сейчас",
          "future": {
            "one": "через {0} сек.",
            "few": "через {0} сек.",
            "many": "через {0} сек.",
            "other": "через {0} сек."
          },
          "past": {
            "one": "{0} сек. назад",
            "few": "{0} сек. назад",
            "many": "{0} сек. назад",
            "other": "{0} сек. назад"
          }
        },
        "second-narrow": {
          "0": "сейчас",
          "future": {
            "one": "+{0} с",
            "few": "+{0} с",
            "many": "+{0} с",
            "other": "+{0} с"
          },
          "past": {
            "one": "-{0} с",
            "few": "-{0} с",
            "many": "-{0} с",
            "other": "-{0} с"
          }
        }
      },
      "ru-MD": {
        "nu": ["latn"],
        "year": {
          "0": "в этом году",
          "1": "в следующем году",
          "future": {
            "one": "через {0} год",
            "few": "через {0} года",
            "many": "через {0} лет",
            "other": "через {0} года"
          },
          "past": {
            "one": "{0} год назад",
            "few": "{0} года назад",
            "many": "{0} лет назад",
            "other": "{0} года назад"
          },
          "-1": "в прошлом году"
        },
        "year-short": {
          "0": "в этом г.",
          "1": "в след. г.",
          "future": {
            "one": "через {0} г.",
            "few": "через {0} г.",
            "many": "через {0} л.",
            "other": "через {0} г."
          },
          "past": {
            "one": "{0} г. назад",
            "few": "{0} г. назад",
            "many": "{0} л. назад",
            "other": "{0} г. назад"
          },
          "-1": "в прошлом г."
        },
        "year-narrow": {
          "0": "в эт. г.",
          "1": "в сл. г.",
          "future": {
            "one": "+{0} г.",
            "few": "+{0} г.",
            "many": "+{0} л.",
            "other": "+{0} г."
          },
          "past": {
            "one": "-{0} г.",
            "few": "-{0} г.",
            "many": "-{0} л.",
            "other": "-{0} г."
          },
          "-1": "в пр. г."
        },
        "quarter": {
          "0": "в текущем квартале",
          "1": "в следующем квартале",
          "future": {
            "one": "через {0} квартал",
            "few": "через {0} квартала",
            "many": "через {0} кварталов",
            "other": "через {0} квартала"
          },
          "past": {
            "one": "{0} квартал назад",
            "few": "{0} квартала назад",
            "many": "{0} кварталов назад",
            "other": "{0} квартала назад"
          },
          "-1": "в прошлом квартале"
        },
        "quarter-short": {
          "0": "текущий кв.",
          "1": "следующий кв.",
          "future": {
            "one": "через {0} кв.",
            "few": "через {0} кв.",
            "many": "через {0} кв.",
            "other": "через {0} кв."
          },
          "past": {
            "one": "{0} кв. назад",
            "few": "{0} кв. назад",
            "many": "{0} кв. назад",
            "other": "{0} кв. назад"
          },
          "-1": "последний кв."
        },
        "quarter-narrow": {
          "0": "тек. кв.",
          "1": "след. кв.",
          "future": {
            "one": "+{0} кв.",
            "few": "+{0} кв.",
            "many": "+{0} кв.",
            "other": "+{0} кв."
          },
          "past": {
            "one": "-{0} кв.",
            "few": "-{0} кв.",
            "many": "-{0} кв.",
            "other": "-{0} кв."
          },
          "-1": "посл. кв."
        },
        "month": {
          "0": "в этом месяце",
          "1": "в следующем месяце",
          "future": {
            "one": "через {0} месяц",
            "few": "через {0} месяца",
            "many": "через {0} месяцев",
            "other": "через {0} месяца"
          },
          "past": {
            "one": "{0} месяц назад",
            "few": "{0} месяца назад",
            "many": "{0} месяцев назад",
            "other": "{0} месяца назад"
          },
          "-1": "в прошлом месяце"
        },
        "month-short": {
          "0": "в этом мес.",
          "1": "в следующем мес.",
          "future": {
            "one": "через {0} мес.",
            "few": "через {0} мес.",
            "many": "через {0} мес.",
            "other": "через {0} мес."
          },
          "past": {
            "one": "{0} мес. назад",
            "few": "{0} мес. назад",
            "many": "{0} мес. назад",
            "other": "{0} мес. назад"
          },
          "-1": "в прошлом мес."
        },
        "month-narrow": {
          "0": "в эт. мес.",
          "1": "в след. мес.",
          "future": {
            "one": "+{0} мес.",
            "few": "+{0} мес.",
            "many": "+{0} мес.",
            "other": "+{0} мес."
          },
          "past": {
            "one": "-{0} мес.",
            "few": "-{0} мес.",
            "many": "-{0} мес.",
            "other": "-{0} мес."
          },
          "-1": "в пр. мес."
        },
        "week": {
          "0": "на этой неделе",
          "1": "на следующей неделе",
          "future": {
            "one": "через {0} неделю",
            "few": "через {0} недели",
            "many": "через {0} недель",
            "other": "через {0} недели"
          },
          "past": {
            "one": "{0} неделю назад",
            "few": "{0} недели назад",
            "many": "{0} недель назад",
            "other": "{0} недели назад"
          },
          "-1": "на прошлой неделе"
        },
        "week-short": {
          "0": "на этой нед.",
          "1": "на следующей нед.",
          "future": {
            "one": "через {0} нед.",
            "few": "через {0} нед.",
            "many": "через {0} нед.",
            "other": "через {0} нед."
          },
          "past": {
            "one": "{0} нед. назад",
            "few": "{0} нед. назад",
            "many": "{0} нед. назад",
            "other": "{0} нед. назад"
          },
          "-1": "на прошлой нед."
        },
        "week-narrow": {
          "0": "на эт. нед.",
          "1": "на след. нед.",
          "future": {
            "one": "+{0} нед.",
            "few": "+{0} нед.",
            "many": "+{0} нед.",
            "other": "+{0} нед."
          },
          "past": {
            "one": "-{0} нед.",
            "few": "-{0} нед.",
            "many": "-{0} нед.",
            "other": "-{0} нед."
          },
          "-1": "на пр. нед."
        },
        "day": {
          "0": "сегодня",
          "1": "завтра",
          "2": "послезавтра",
          "future": {
            "one": "через {0} день",
            "few": "через {0} дня",
            "many": "через {0} дней",
            "other": "через {0} дня"
          },
          "past": {
            "one": "{0} день назад",
            "few": "{0} дня назад",
            "many": "{0} дней назад",
            "other": "{0} дня назад"
          },
          "-2": "позавчера",
          "-1": "вчера"
        },
        "day-short": {
          "0": "сегодня",
          "1": "завтра",
          "2": "послезавтра",
          "future": {
            "one": "через {0} дн.",
            "few": "через {0} дн.",
            "many": "через {0} дн.",
            "other": "через {0} дн."
          },
          "past": {
            "one": "{0} дн. назад",
            "few": "{0} дн. назад",
            "many": "{0} дн. назад",
            "other": "{0} дн. назад"
          },
          "-2": "позавчера",
          "-1": "вчера"
        },
        "day-narrow": {
          "0": "сегодня",
          "1": "завтра",
          "2": "послезавтра",
          "future": {
            "one": "+{0} дн.",
            "few": "+{0} дн.",
            "many": "+{0} дн.",
            "other": "+{0} дн."
          },
          "past": {
            "one": "-{0} дн.",
            "few": "-{0} дн.",
            "many": "-{0} дн.",
            "other": "-{0} дн."
          },
          "-2": "позавчера",
          "-1": "вчера"
        },
        "hour": {
          "0": "в этот час",
          "future": {
            "one": "через {0} час",
            "few": "через {0} часа",
            "many": "через {0} часов",
            "other": "через {0} часа"
          },
          "past": {
            "one": "{0} час назад",
            "few": "{0} часа назад",
            "many": "{0} часов назад",
            "other": "{0} часа назад"
          }
        },
        "hour-short": {
          "0": "в этот час",
          "future": {
            "one": "через {0} ч",
            "few": "через {0} ч",
            "many": "через {0} ч",
            "other": "через {0} ч"
          },
          "past": {
            "one": "{0} ч назад",
            "few": "{0} ч назад",
            "many": "{0} ч назад",
            "other": "{0} ч назад"
          }
        },
        "hour-narrow": {
          "0": "в этот час",
          "future": {
            "one": "+{0} ч",
            "few": "+{0} ч",
            "many": "+{0} ч",
            "other": "+{0} ч"
          },
          "past": {
            "one": "-{0} ч",
            "few": "-{0} ч",
            "many": "-{0} ч",
            "other": "-{0} ч"
          }
        },
        "minute": {
          "0": "в эту минуту",
          "future": {
            "one": "через {0} минуту",
            "few": "через {0} минуты",
            "many": "через {0} минут",
            "other": "через {0} минуты"
          },
          "past": {
            "one": "{0} минуту назад",
            "few": "{0} минуты назад",
            "many": "{0} минут назад",
            "other": "{0} минуты назад"
          }
        },
        "minute-short": {
          "0": "в эту минуту",
          "future": {
            "one": "через {0} мин.",
            "few": "через {0} мин.",
            "many": "через {0} мин.",
            "other": "через {0} мин."
          },
          "past": {
            "one": "{0} мин. назад",
            "few": "{0} мин. назад",
            "many": "{0} мин. назад",
            "other": "{0} мин. назад"
          }
        },
        "minute-narrow": {
          "0": "в эту минуту",
          "future": {
            "one": "+{0} мин",
            "few": "+{0} мин",
            "many": "+{0} мин",
            "other": "+{0} мин"
          },
          "past": {
            "one": "-{0} мин",
            "few": "-{0} мин",
            "many": "-{0} мин",
            "other": "-{0} мин"
          }
        },
        "second": {
          "0": "сейчас",
          "future": {
            "one": "через {0} секунду",
            "few": "через {0} секунды",
            "many": "через {0} секунд",
            "other": "через {0} секунды"
          },
          "past": {
            "one": "{0} секунду назад",
            "few": "{0} секунды назад",
            "many": "{0} секунд назад",
            "other": "{0} секунды назад"
          }
        },
        "second-short": {
          "0": "сейчас",
          "future": {
            "one": "через {0} сек.",
            "few": "через {0} сек.",
            "many": "через {0} сек.",
            "other": "через {0} сек."
          },
          "past": {
            "one": "{0} сек. назад",
            "few": "{0} сек. назад",
            "many": "{0} сек. назад",
            "other": "{0} сек. назад"
          }
        },
        "second-narrow": {
          "0": "сейчас",
          "future": {
            "one": "+{0} с",
            "few": "+{0} с",
            "many": "+{0} с",
            "other": "+{0} с"
          },
          "past": {
            "one": "-{0} с",
            "few": "-{0} с",
            "many": "-{0} с",
            "other": "-{0} с"
          }
        }
      },
      "ru-UA": {
        "nu": ["latn"],
        "year": {
          "0": "в этом году",
          "1": "в следующем году",
          "future": {
            "one": "через {0} год",
            "few": "через {0} года",
            "many": "через {0} лет",
            "other": "через {0} года"
          },
          "past": {
            "one": "{0} год назад",
            "few": "{0} года назад",
            "many": "{0} лет назад",
            "other": "{0} года назад"
          },
          "-1": "в прошлом году"
        },
        "year-short": {
          "0": "в этом г.",
          "1": "в след. г.",
          "future": {
            "one": "через {0} г.",
            "few": "через {0} г.",
            "many": "через {0} л.",
            "other": "через {0} г."
          },
          "past": {
            "one": "{0} г. назад",
            "few": "{0} г. назад",
            "many": "{0} л. назад",
            "other": "{0} г. назад"
          },
          "-1": "в прошлом г."
        },
        "year-narrow": {
          "0": "в эт. г.",
          "1": "в сл. г.",
          "future": {
            "one": "+{0} г.",
            "few": "+{0} г.",
            "many": "+{0} л.",
            "other": "+{0} г."
          },
          "past": {
            "one": "-{0} г.",
            "few": "-{0} г.",
            "many": "-{0} л.",
            "other": "-{0} г."
          },
          "-1": "в пр. г."
        },
        "quarter": {
          "0": "в текущем квартале",
          "1": "в следующем квартале",
          "future": {
            "one": "через {0} квартал",
            "few": "через {0} квартала",
            "many": "через {0} кварталов",
            "other": "через {0} квартала"
          },
          "past": {
            "one": "{0} квартал назад",
            "few": "{0} квартала назад",
            "many": "{0} кварталов назад",
            "other": "{0} квартала назад"
          },
          "-1": "в прошлом квартале"
        },
        "quarter-short": {
          "0": "текущий кв.",
          "1": "следующий кв.",
          "future": {
            "one": "через {0} кв.",
            "few": "через {0} кв.",
            "many": "через {0} кв.",
            "other": "через {0} кв."
          },
          "past": {
            "one": "{0} кв. назад",
            "few": "{0} кв. назад",
            "many": "{0} кв. назад",
            "other": "{0} кв. назад"
          },
          "-1": "последний кв."
        },
        "quarter-narrow": {
          "0": "тек. кв.",
          "1": "след. кв.",
          "future": {
            "one": "+{0} кв.",
            "few": "+{0} кв.",
            "many": "+{0} кв.",
            "other": "+{0} кв."
          },
          "past": {
            "one": "-{0} кв.",
            "few": "-{0} кв.",
            "many": "-{0} кв.",
            "other": "-{0} кв."
          },
          "-1": "посл. кв."
        },
        "month": {
          "0": "в этом месяце",
          "1": "в следующем месяце",
          "future": {
            "one": "через {0} месяц",
            "few": "через {0} месяца",
            "many": "через {0} месяцев",
            "other": "через {0} месяца"
          },
          "past": {
            "one": "{0} месяц назад",
            "few": "{0} месяца назад",
            "many": "{0} месяцев назад",
            "other": "{0} месяца назад"
          },
          "-1": "в прошлом месяце"
        },
        "month-short": {
          "0": "в этом мес.",
          "1": "в следующем мес.",
          "future": {
            "one": "через {0} мес.",
            "few": "через {0} мес.",
            "many": "через {0} мес.",
            "other": "через {0} мес."
          },
          "past": {
            "one": "{0} мес. назад",
            "few": "{0} мес. назад",
            "many": "{0} мес. назад",
            "other": "{0} мес. назад"
          },
          "-1": "в прошлом мес."
        },
        "month-narrow": {
          "0": "в эт. мес.",
          "1": "в след. мес.",
          "future": {
            "one": "+{0} мес.",
            "few": "+{0} мес.",
            "many": "+{0} мес.",
            "other": "+{0} мес."
          },
          "past": {
            "one": "-{0} мес.",
            "few": "-{0} мес.",
            "many": "-{0} мес.",
            "other": "-{0} мес."
          },
          "-1": "в пр. мес."
        },
        "week": {
          "0": "на этой неделе",
          "1": "на следующей неделе",
          "future": {
            "one": "через {0} неделю",
            "few": "через {0} недели",
            "many": "через {0} недель",
            "other": "через {0} недели"
          },
          "past": {
            "one": "{0} неделю назад",
            "few": "{0} недели назад",
            "many": "{0} недель назад",
            "other": "{0} недели назад"
          },
          "-1": "на прошлой неделе"
        },
        "week-short": {
          "0": "на этой нед.",
          "1": "на следующей нед.",
          "future": {
            "one": "через {0} нед.",
            "few": "через {0} нед.",
            "many": "через {0} нед.",
            "other": "через {0} нед."
          },
          "past": {
            "one": "{0} нед. назад",
            "few": "{0} нед. назад",
            "many": "{0} нед. назад",
            "other": "{0} нед. назад"
          },
          "-1": "на прошлой нед."
        },
        "week-narrow": {
          "0": "на эт. нед.",
          "1": "на след. нед.",
          "future": {
            "one": "+{0} нед.",
            "few": "+{0} нед.",
            "many": "+{0} нед.",
            "other": "+{0} нед."
          },
          "past": {
            "one": "-{0} нед.",
            "few": "-{0} нед.",
            "many": "-{0} нед.",
            "other": "-{0} нед."
          },
          "-1": "на пр. нед."
        },
        "day": {
          "0": "сегодня",
          "1": "завтра",
          "2": "послезавтра",
          "future": {
            "one": "через {0} день",
            "few": "через {0} дня",
            "many": "через {0} дней",
            "other": "через {0} дня"
          },
          "past": {
            "one": "{0} день назад",
            "few": "{0} дня назад",
            "many": "{0} дней назад",
            "other": "{0} дня назад"
          },
          "-2": "позавчера",
          "-1": "вчера"
        },
        "day-short": {
          "0": "сегодня",
          "1": "завтра",
          "2": "послезавтра",
          "future": {
            "one": "через {0} дн.",
            "few": "через {0} дн.",
            "many": "через {0} дн.",
            "other": "через {0} дн."
          },
          "past": {
            "one": "{0} дн. назад",
            "few": "{0} дн. назад",
            "many": "{0} дн. назад",
            "other": "{0} дн. назад"
          },
          "-2": "позавчера",
          "-1": "вчера"
        },
        "day-narrow": {
          "0": "сегодня",
          "1": "завтра",
          "2": "послезавтра",
          "future": {
            "one": "+{0} дн.",
            "few": "+{0} дн.",
            "many": "+{0} дн.",
            "other": "+{0} дн."
          },
          "past": {
            "one": "-{0} дн.",
            "few": "-{0} дн.",
            "many": "-{0} дн.",
            "other": "-{0} дн."
          },
          "-2": "позавчера",
          "-1": "вчера"
        },
        "hour": {
          "0": "в этот час",
          "future": {
            "one": "через {0} час",
            "few": "через {0} часа",
            "many": "через {0} часов",
            "other": "через {0} часа"
          },
          "past": {
            "one": "{0} час назад",
            "few": "{0} часа назад",
            "many": "{0} часов назад",
            "other": "{0} часа назад"
          }
        },
        "hour-short": {
          "0": "в этот час",
          "future": {
            "one": "через {0} ч",
            "few": "через {0} ч",
            "many": "через {0} ч",
            "other": "через {0} ч"
          },
          "past": {
            "one": "{0} ч назад",
            "few": "{0} ч назад",
            "many": "{0} ч назад",
            "other": "{0} ч назад"
          }
        },
        "hour-narrow": {
          "0": "в этот час",
          "future": {
            "one": "+{0} ч",
            "few": "+{0} ч",
            "many": "+{0} ч",
            "other": "+{0} ч"
          },
          "past": {
            "one": "-{0} ч",
            "few": "-{0} ч",
            "many": "-{0} ч",
            "other": "-{0} ч"
          }
        },
        "minute": {
          "0": "в эту минуту",
          "future": {
            "one": "через {0} минуту",
            "few": "через {0} минуты",
            "many": "через {0} минут",
            "other": "через {0} минуты"
          },
          "past": {
            "one": "{0} минуту назад",
            "few": "{0} минуты назад",
            "many": "{0} минут назад",
            "other": "{0} минуты назад"
          }
        },
        "minute-short": {
          "0": "в эту минуту",
          "future": {
            "one": "через {0} мин.",
            "few": "через {0} мин.",
            "many": "через {0} мин.",
            "other": "через {0} мин."
          },
          "past": {
            "one": "{0} мин. назад",
            "few": "{0} мин. назад",
            "many": "{0} мин. назад",
            "other": "{0} мин. назад"
          }
        },
        "minute-narrow": {
          "0": "в эту минуту",
          "future": {
            "one": "+{0} мин",
            "few": "+{0} мин",
            "many": "+{0} мин",
            "other": "+{0} мин"
          },
          "past": {
            "one": "-{0} мин",
            "few": "-{0} мин",
            "many": "-{0} мин",
            "other": "-{0} мин"
          }
        },
        "second": {
          "0": "сейчас",
          "future": {
            "one": "через {0} секунду",
            "few": "через {0} секунды",
            "many": "через {0} секунд",
            "other": "через {0} секунды"
          },
          "past": {
            "one": "{0} секунду назад",
            "few": "{0} секунды назад",
            "many": "{0} секунд назад",
            "other": "{0} секунды назад"
          }
        },
        "second-short": {
          "0": "сейчас",
          "future": {
            "one": "через {0} сек.",
            "few": "через {0} сек.",
            "many": "через {0} сек.",
            "other": "через {0} сек."
          },
          "past": {
            "one": "{0} сек. назад",
            "few": "{0} сек. назад",
            "many": "{0} сек. назад",
            "other": "{0} сек. назад"
          }
        },
        "second-narrow": {
          "0": "сейчас",
          "future": {
            "one": "+{0} с",
            "few": "+{0} с",
            "many": "+{0} с",
            "other": "+{0} с"
          },
          "past": {
            "one": "-{0} с",
            "few": "-{0} с",
            "many": "-{0} с",
            "other": "-{0} с"
          }
        }
      },
      "ru": {
        "nu": ["latn"],
        "year": {
          "0": "в этом году",
          "1": "в следующем году",
          "future": {
            "one": "через {0} год",
            "few": "через {0} года",
            "many": "через {0} лет",
            "other": "через {0} года"
          },
          "past": {
            "one": "{0} год назад",
            "few": "{0} года назад",
            "many": "{0} лет назад",
            "other": "{0} года назад"
          },
          "-1": "в прошлом году"
        },
        "year-short": {
          "0": "в этом г.",
          "1": "в след. г.",
          "future": {
            "one": "через {0} г.",
            "few": "через {0} г.",
            "many": "через {0} л.",
            "other": "через {0} г."
          },
          "past": {
            "one": "{0} г. назад",
            "few": "{0} г. назад",
            "many": "{0} л. назад",
            "other": "{0} г. назад"
          },
          "-1": "в прошлом г."
        },
        "year-narrow": {
          "0": "в эт. г.",
          "1": "в сл. г.",
          "future": {
            "one": "+{0} г.",
            "few": "+{0} г.",
            "many": "+{0} л.",
            "other": "+{0} г."
          },
          "past": {
            "one": "-{0} г.",
            "few": "-{0} г.",
            "many": "-{0} л.",
            "other": "-{0} г."
          },
          "-1": "в пр. г."
        },
        "quarter": {
          "0": "в текущем квартале",
          "1": "в следующем квартале",
          "future": {
            "one": "через {0} квартал",
            "few": "через {0} квартала",
            "many": "через {0} кварталов",
            "other": "через {0} квартала"
          },
          "past": {
            "one": "{0} квартал назад",
            "few": "{0} квартала назад",
            "many": "{0} кварталов назад",
            "other": "{0} квартала назад"
          },
          "-1": "в прошлом квартале"
        },
        "quarter-short": {
          "0": "текущий кв.",
          "1": "следующий кв.",
          "future": {
            "one": "через {0} кв.",
            "few": "через {0} кв.",
            "many": "через {0} кв.",
            "other": "через {0} кв."
          },
          "past": {
            "one": "{0} кв. назад",
            "few": "{0} кв. назад",
            "many": "{0} кв. назад",
            "other": "{0} кв. назад"
          },
          "-1": "последний кв."
        },
        "quarter-narrow": {
          "0": "тек. кв.",
          "1": "след. кв.",
          "future": {
            "one": "+{0} кв.",
            "few": "+{0} кв.",
            "many": "+{0} кв.",
            "other": "+{0} кв."
          },
          "past": {
            "one": "-{0} кв.",
            "few": "-{0} кв.",
            "many": "-{0} кв.",
            "other": "-{0} кв."
          },
          "-1": "посл. кв."
        },
        "month": {
          "0": "в этом месяце",
          "1": "в следующем месяце",
          "future": {
            "one": "через {0} месяц",
            "few": "через {0} месяца",
            "many": "через {0} месяцев",
            "other": "через {0} месяца"
          },
          "past": {
            "one": "{0} месяц назад",
            "few": "{0} месяца назад",
            "many": "{0} месяцев назад",
            "other": "{0} месяца назад"
          },
          "-1": "в прошлом месяце"
        },
        "month-short": {
          "0": "в этом мес.",
          "1": "в следующем мес.",
          "future": {
            "one": "через {0} мес.",
            "few": "через {0} мес.",
            "many": "через {0} мес.",
            "other": "через {0} мес."
          },
          "past": {
            "one": "{0} мес. назад",
            "few": "{0} мес. назад",
            "many": "{0} мес. назад",
            "other": "{0} мес. назад"
          },
          "-1": "в прошлом мес."
        },
        "month-narrow": {
          "0": "в эт. мес.",
          "1": "в след. мес.",
          "future": {
            "one": "+{0} мес.",
            "few": "+{0} мес.",
            "many": "+{0} мес.",
            "other": "+{0} мес."
          },
          "past": {
            "one": "-{0} мес.",
            "few": "-{0} мес.",
            "many": "-{0} мес.",
            "other": "-{0} мес."
          },
          "-1": "в пр. мес."
        },
        "week": {
          "0": "на этой неделе",
          "1": "на следующей неделе",
          "future": {
            "one": "через {0} неделю",
            "few": "через {0} недели",
            "many": "через {0} недель",
            "other": "через {0} недели"
          },
          "past": {
            "one": "{0} неделю назад",
            "few": "{0} недели назад",
            "many": "{0} недель назад",
            "other": "{0} недели назад"
          },
          "-1": "на прошлой неделе"
        },
        "week-short": {
          "0": "на этой нед.",
          "1": "на следующей нед.",
          "future": {
            "one": "через {0} нед.",
            "few": "через {0} нед.",
            "many": "через {0} нед.",
            "other": "через {0} нед."
          },
          "past": {
            "one": "{0} нед. назад",
            "few": "{0} нед. назад",
            "many": "{0} нед. назад",
            "other": "{0} нед. назад"
          },
          "-1": "на прошлой нед."
        },
        "week-narrow": {
          "0": "на эт. нед.",
          "1": "на след. нед.",
          "future": {
            "one": "+{0} нед.",
            "few": "+{0} нед.",
            "many": "+{0} нед.",
            "other": "+{0} нед."
          },
          "past": {
            "one": "-{0} нед.",
            "few": "-{0} нед.",
            "many": "-{0} нед.",
            "other": "-{0} нед."
          },
          "-1": "на пр. нед."
        },
        "day": {
          "0": "сегодня",
          "1": "завтра",
          "2": "послезавтра",
          "future": {
            "one": "через {0} день",
            "few": "через {0} дня",
            "many": "через {0} дней",
            "other": "через {0} дня"
          },
          "past": {
            "one": "{0} день назад",
            "few": "{0} дня назад",
            "many": "{0} дней назад",
            "other": "{0} дня назад"
          },
          "-2": "позавчера",
          "-1": "вчера"
        },
        "day-short": {
          "0": "сегодня",
          "1": "завтра",
          "2": "послезавтра",
          "future": {
            "one": "через {0} дн.",
            "few": "через {0} дн.",
            "many": "через {0} дн.",
            "other": "через {0} дн."
          },
          "past": {
            "one": "{0} дн. назад",
            "few": "{0} дн. назад",
            "many": "{0} дн. назад",
            "other": "{0} дн. назад"
          },
          "-2": "позавчера",
          "-1": "вчера"
        },
        "day-narrow": {
          "0": "сегодня",
          "1": "завтра",
          "2": "послезавтра",
          "future": {
            "one": "+{0} дн.",
            "few": "+{0} дн.",
            "many": "+{0} дн.",
            "other": "+{0} дн."
          },
          "past": {
            "one": "-{0} дн.",
            "few": "-{0} дн.",
            "many": "-{0} дн.",
            "other": "-{0} дн."
          },
          "-2": "позавчера",
          "-1": "вчера"
        },
        "hour": {
          "0": "в этот час",
          "future": {
            "one": "через {0} час",
            "few": "через {0} часа",
            "many": "через {0} часов",
            "other": "через {0} часа"
          },
          "past": {
            "one": "{0} час назад",
            "few": "{0} часа назад",
            "many": "{0} часов назад",
            "other": "{0} часа назад"
          }
        },
        "hour-short": {
          "0": "в этот час",
          "future": {
            "one": "через {0} ч",
            "few": "через {0} ч",
            "many": "через {0} ч",
            "other": "через {0} ч"
          },
          "past": {
            "one": "{0} ч назад",
            "few": "{0} ч назад",
            "many": "{0} ч назад",
            "other": "{0} ч назад"
          }
        },
        "hour-narrow": {
          "0": "в этот час",
          "future": {
            "one": "+{0} ч",
            "few": "+{0} ч",
            "many": "+{0} ч",
            "other": "+{0} ч"
          },
          "past": {
            "one": "-{0} ч",
            "few": "-{0} ч",
            "many": "-{0} ч",
            "other": "-{0} ч"
          }
        },
        "minute": {
          "0": "в эту минуту",
          "future": {
            "one": "через {0} минуту",
            "few": "через {0} минуты",
            "many": "через {0} минут",
            "other": "через {0} минуты"
          },
          "past": {
            "one": "{0} минуту назад",
            "few": "{0} минуты назад",
            "many": "{0} минут назад",
            "other": "{0} минуты назад"
          }
        },
        "minute-short": {
          "0": "в эту минуту",
          "future": {
            "one": "через {0} мин.",
            "few": "через {0} мин.",
            "many": "через {0} мин.",
            "other": "через {0} мин."
          },
          "past": {
            "one": "{0} мин. назад",
            "few": "{0} мин. назад",
            "many": "{0} мин. назад",
            "other": "{0} мин. назад"
          }
        },
        "minute-narrow": {
          "0": "в эту минуту",
          "future": {
            "one": "+{0} мин",
            "few": "+{0} мин",
            "many": "+{0} мин",
            "other": "+{0} мин"
          },
          "past": {
            "one": "-{0} мин",
            "few": "-{0} мин",
            "many": "-{0} мин",
            "other": "-{0} мин"
          }
        },
        "second": {
          "0": "сейчас",
          "future": {
            "one": "через {0} секунду",
            "few": "через {0} секунды",
            "many": "через {0} секунд",
            "other": "через {0} секунды"
          },
          "past": {
            "one": "{0} секунду назад",
            "few": "{0} секунды назад",
            "many": "{0} секунд назад",
            "other": "{0} секунды назад"
          }
        },
        "second-short": {
          "0": "сейчас",
          "future": {
            "one": "через {0} сек.",
            "few": "через {0} сек.",
            "many": "через {0} сек.",
            "other": "через {0} сек."
          },
          "past": {
            "one": "{0} сек. назад",
            "few": "{0} сек. назад",
            "many": "{0} сек. назад",
            "other": "{0} сек. назад"
          }
        },
        "second-narrow": {
          "0": "сейчас",
          "future": {
            "one": "+{0} с",
            "few": "+{0} с",
            "many": "+{0} с",
            "other": "+{0} с"
          },
          "past": {
            "one": "-{0} с",
            "few": "-{0} с",
            "many": "-{0} с",
            "other": "-{0} с"
          }
        }
      }
    },
    "availableLocales": ["ru-BY", "ru-KG", "ru-KZ", "ru-MD", "ru-UA", "ru"]
  });
}